
import { Vue, Component } from 'vue-property-decorator';
import { getDetail } from '../api';
import { ImagePreview } from 'vant';
Vue.use(ImagePreview);
@Component
export default class Detail extends Vue {
  id: any = '';
  obj: any = {};
  async mounted() {
    this.id = this.$route.query.id;
    const res: any = await getDetail(this.id);
    this.obj = res.data;
  }
  showImg(url: any, index: any) {
    console.log(url, index);
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: url, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }
}
